module.exports = __webpack_public_path__ + "static/media/quill.e19e620b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/quill.svg
// module id = 63
// module chunks = 0